module.exports = __webpack_public_path__ + "img/Astralis-white.14895873.png";